/**
 * Mobile Features Module
 *
 * This module handles mobile-specific features on the homepage
 */

import jQuery from 'jquery';
import { gsap, TimelineMax, Power2 } from 'gsap';

const MobileFeatures = {
  setupMobileTouchEvents: function () {
    // Set up mobile touch events for the slider
    const mobileSlider = jQuery('.home-mobile-slider');
    if (mobileSlider.length === 0) return;

    let startX, startY;
    let distX, distY;
    const threshold = 150; // Minimum distance for swipe to register
    const restraint = 100; // Maximum perpendicular distance for swipe to register
    const allowedTime = 300; // Maximum time allowed for swipe
    let startTime;
    let currentSlide = 0;
    const slideCount = jQuery('.home-mobile-slide').length;

    // Event listeners
    mobileSlider.on('touchstart', function (e) {
      const touchObj = e.originalEvent.changedTouches[0];
      startX = touchObj.pageX;
      startY = touchObj.pageY;
      startTime = new Date().getTime();
      e.preventDefault();
    });

    mobileSlider.on('touchend', function (e) {
      const touchObj = e.originalEvent.changedTouches[0];
      distX = touchObj.pageX - startX;
      distY = touchObj.pageY - startY;
      const elapsedTime = new Date().getTime() - startTime;

      if (elapsedTime <= allowedTime) {
        if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
          // Horizontal swipe detected
          if (distX > 0) {
            // Right swipe - previous slide
            currentSlide = (currentSlide - 1 + slideCount) % slideCount;
          } else {
            // Left swipe - next slide
            currentSlide = (currentSlide + 1) % slideCount;
          }

          // Update slides and indicators
          jQuery('.home-mobile-slide').removeClass('active');
          jQuery('.home-mobile-slide').eq(currentSlide).addClass('active');

          jQuery('.home-mobile-indicator').removeClass('active');
          jQuery('.home-mobile-indicator').eq(currentSlide).addClass('active');
        }
      }
      e.preventDefault();
    });

    // Set up indicators
    jQuery('.home-mobile-indicator').on('click', function () {
      const index = jQuery(this).index();
      currentSlide = index;

      jQuery('.home-mobile-slide').removeClass('active');
      jQuery('.home-mobile-slide').eq(currentSlide).addClass('active');

      jQuery('.home-mobile-indicator').removeClass('active');
      jQuery(this).addClass('active');
    });
  },

  setupMobileMenuToggle: function () {
    // Mobile menu toggle
    const menuToggle = jQuery('.mobile-menu-toggle');
    const mobileMenu = jQuery('.mobile-menu');

    menuToggle.on('click', function () {
      menuToggle.toggleClass('active');
      mobileMenu.toggleClass('active');
      jQuery('body').toggleClass('menu-open');
    });
  },

  setupScrollToTop: function () {
    // Scroll to top button
    const scrollTopBtn = jQuery('.scroll-top-btn');

    jQuery(window).on('scroll', function () {
      if (jQuery(this).scrollTop() > 300) {
        scrollTopBtn.addClass('visible');
      } else {
        scrollTopBtn.removeClass('visible');
      }
    });

    scrollTopBtn.on('click', function () {
      jQuery('html, body').animate({ scrollTop: 0 }, 800);
      return false;
    });
  },

  init: function () {
    // Only run on mobile devices
    if (window.innerWidth <= 768) {
      this.setupMobileTouchEvents();
      this.setupMobileMenuToggle();
      this.setupScrollToTop();
    }

    // Listen for resize events to enable/disable mobile features
    jQuery(window).on('resize', () => {
      if (window.innerWidth <= 768) {
        this.setupMobileTouchEvents();
        this.setupMobileMenuToggle();
        this.setupScrollToTop();
      }
    });
  },
};

export default MobileFeatures;
